import { render, staticRenderFns } from "./CollapseNavItem.vue?vue&type=template&id=420de9ca&scoped=true&"
import script from "./CollapseNavItem.vue?vue&type=script&lang=js&"
export * from "./CollapseNavItem.vue?vue&type=script&lang=js&"
import style0 from "./CollapseNavItem.vue?vue&type=style&index=0&id=420de9ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420de9ca",
  null
  
)

export default component.exports